import React, { useState, useEffect } from "react";
// @ts-ignore
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetFooter } from "../ui/sheet.tsx"
import {
    Building2,
    User2
} from "lucide-react"
import CircularProgress from '@mui/material/CircularProgress';

const ContactUsForm = (props) => {
    const [inputValues, setInputValues] = useState({
        name: null,
        company: null,
        email: null,
        message: null
    });

    const [errors, setErrors] = useState({
        name: false,
        company: false,
        email: false,
        message: false
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        props.setIsShow(false);
    }

    const onChange = (event) => {
        setInputValues({ ...inputValues, [event?.target?.id]: event?.target?.value });
    }

    const onSubmit = async () => {
        setIsLoading(true);
        const newErrors = {
            name: !inputValues.name ? true : false,
            company: !inputValues.company ? true : false,
            email: !inputValues.email ? true : false,
            message: !inputValues.message ? true : false
        };

        setErrors(newErrors);

        console.log("newErrors", newErrors);

        if (newErrors.name || newErrors.company || newErrors.email || newErrors.message) {
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch(process.env.REACT_APP_EMAIL_SENDER, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(inputValues),
            });

            if (response?.status === 200) {
                setInputValues({
                    name: null,
                    company: null,
                    email: null,
                    message: null
                });
                props.setIsShow(false);
                setIsLoading(true);
            } else {
                props.setIsShow(true);
                setIsLoading(true);
            }
        } catch (error) {
            console.log("error", error);
            setIsLoading(true);
        }
    }

    return (
        <div>
            <Sheet open={props?.isShow} onOpenChange={props.setIsShow}>
                <SheetContent side="right" className="h-screen w-full min-w-[600px] p-0 overflow-auto fixed z-50 bg-[#171514] box-border content-stretch flex flex-col gap-[26px] h-screen items-center justify-start right-0 pb-8 pt-[55px] px-6 rounded-l-2xl top-0 w-[35vw] transition-transform duration-500 ease-out">
                    <div className="my-contact-form box-border content-stretch flex flex-col gap-[26px] items-center justify-start p-0 relative shrink-0 w-full">
                        <div className="font-['Helvetica_Neue:Regular',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#f3daa3] text-[40px] text-left text-nowrap tracking-[-0.88px]">
                            <p className="font-['Helvetica_Neue:Light',_sans-serif] leading-[1.2] whitespace-pre">
                                <span>{`Let us `}</span>
                                <span className="adjustLetterSpacing text-[#ffffff]">
                                    get to know you
                                </span>
                            </p>
                        </div>
                        <div className="box-border content-stretch flex flex-col gap-3 items-start justify-start p-0 relative shrink-0 w-full">
                            <div className="font-['Helvetica_Neue:Light',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#a7a7a7] text-[20px] text-left tracking-[-0.44px] w-full">
                                <p className="block leading-none">Name</p>
                            </div>
                            <div className="bg-[#171514] relative rounded shrink-0 w-full">
                                <div
                                    aria-hidden="true"
                                    className={`absolute bg-transparent ${errors?.name ? "border border-red-500 focus-visible:ring-red-500 border-solid inset-[-1px]" : "border border-[rgba(255,255,255,0.12)] border-solid inset-[-1px]"}  pointer-events-none rounded-[5px]`}
                                />
                                <div className="flex flex-row items-center relative size-full">
                                    <div className="box-border bg-transparent content-stretch flex flex-row gap-2.5 items-center justify-start px-3.5 py-4 relative w-full">
                                        <input
                                            type="text"
                                            id="name"
                                            value={inputValues.name}
                                            onChange={(e) => onChange(e)}
                                            placeholder="Enter your name"
                                            className="font-['Helvetica_Neue:Regular',_sans-serif] leading-[0] not-italic bg-transparent text-[#ffffff] text-[18px] tracking-[-0.396px] w-full outline-none placeholder:text-[#666666]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box-border content-stretch flex flex-col gap-3 items-start justify-start p-0 relative shrink-0 w-full">
                            <div className="font-['Helvetica_Neue:Light',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#a7a7a7] text-[20px] text-left tracking-[-0.44px] w-full">
                                <p className="block leading-none">Company name</p>
                            </div>
                            <div className="bg-[#171514] relative rounded shrink-0 w-full">
                                <div
                                    aria-hidden="true"
                                    className={`absolute ${errors?.company ? "border border-red-500 focus-visible:ring-red-500 border-solid inset-[-1px]" : "border border-[rgba(255,255,255,0.12)] border-solid inset-[-1px]"}  pointer-events-none rounded-[5px]`}
                                />
                                <div className="flex flex-row items-center relative size-full">
                                    <div className="box-border content-stretch flex flex-row gap-2.5 items-center justify-start px-3.5 py-4 relative w-full">
                                        <input
                                            type="text"
                                            id="company"
                                            value={inputValues.company}
                                            onChange={(e) => onChange(e)}
                                            placeholder="Enter company name"
                                            className="font-['Helvetica_Neue:Regular',_sans-serif] leading-[0] not-italic bg-transparent text-[#ffffff] text-[18px] tracking-[-0.396px] w-full outline-none placeholder:text-[#666666]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box-border content-stretch flex flex-col gap-3 items-start justify-start p-0 relative shrink-0 w-full">
                            <div className="font-['Helvetica_Neue:Light',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#a7a7a7] text-[20px] text-left tracking-[-0.44px] w-full">
                                <p className="block leading-none">Email</p>
                            </div>
                            <div className="bg-[#171514] relative rounded shrink-0 w-full">
                                <div
                                    aria-hidden="true"
                                    className={`absolute ${errors?.email ? "border border-red-500 focus-visible:ring-red-500 border-solid inset-[-1px]" : "border border-[rgba(255,255,255,0.12)] border-solid inset-[-1px]"}  pointer-events-none rounded-[5px]`}
                                />
                                <div className="flex flex-row items-center relative size-full">
                                    <div className="box-border content-stretch flex flex-row gap-2.5 items-center justify-start px-3.5 py-4 relative w-full">
                                        <input
                                            type="email"
                                            id="email"
                                            value={inputValues.email}
                                            onChange={(e) => onChange(e)}
                                            placeholder="Enter your email"
                                            className="font-['Helvetica_Neue:Regular',_sans-serif] leading-[0] not-italic bg-transparent text-[#ffffff] text-[18px] tracking-[-0.396px] w-full outline-none placeholder:text-[#666666]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="box-border content-stretch flex flex-col gap-3 h-[140px] items-start justify-start p-0 relative shrink-0 w-full">
                            <div className="font-['Helvetica_Neue:Light',_sans-serif] leading-[0] not-italic relative shrink-0 text-[#a7a7a7] text-[20px] text-left tracking-[-0.44px] w-full">
                                <p className="block leading-none">Tell us about your needs</p>
                            </div>
                            <div className="bg-[#171514] h-[108px] relative rounded shrink-0 w-full">
                                <div
                                    aria-hidden="true"
                                    className={`absolute ${errors?.message ? "border border-red-500 focus-visible:ring-red-500 border-solid inset-[-1px]" : "border border-[rgba(255,255,255,0.12)] border-solid inset-[-1px]"}  pointer-events-none rounded-[5px]`}
                                />
                                <div className="relative size-full">
                                    <div className="box-border content-stretch flex flex-row gap-2.5 h-[108px] items-start justify-start px-3.5 py-4 relative w-full">
                                        <textarea
                                            id="message"
                                            value={inputValues.message}
                                            onChange={(e) => onChange(e)}
                                            placeholder="Tell us about your project, goals, or any specific requirements..."
                                            className="font-['Helvetica_Neue:Regular',_sans-serif] leading-[1.4] not-italic bg-transparent text-[#ffffff] text-[18px] tracking-[-0.396px] w-full h-full outline-none resize-none placeholder:text-[#666666]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={onSubmit}
                            disabled={isLoading}
                            className="grey text-[#ffffff] box-border content-stretch flex flex-row gap-2.5 h-12 items-center justify-center pl-[15px] pr-1 py-1 relative rounded-[75px] shrink-0 hover:bg-[rgba(255,255,255,0.8)] transition-colors cursor-pointer"
                        >
                            <div
                                aria-hidden="true"
                                className="absolute border text-[#ffffff]  border-[rgba(255,255,255,0.5)] border-solid inset-[-1px] pointer-events-none rounded-[76px]"
                            />
                            <div className="flex flex-col font-['Helvetica_Neue:Regular',_sans-serif] justify-end leading-[0] not-italic relative shrink-0 text-[#101010] text-[14px] text-left text-nowrap">
                                <p className="block leading-none whitespace-pre text-[#ffffff] ">{isLoading && (<CircularProgress color="inherit" size="15px"/>)} Send Inquiry</p>
                            </div>
                        </button>
                    </div>
                </SheetContent>
            </Sheet>
        </div>
    );
};

export default ContactUsForm;
